import React, { FC, use, useCallback, useEffect } from "react";
import useWebSocket from "react-use-websocket";
import { Slide, toast, ToastContainer } from "react-toastify";
import Toast from "../themed/alert/Toast";
import { isResultMessage } from "../../models/DTOs";
import { NotificationContext } from "../../context/notification/NotificationContext";
import { config } from "../../const";

const Notification: FC = () => {

    const WS_URL = `${config.webSocketBaseUrl}/notifications`;
    const { lastJsonMessage, lastMessage } = useWebSocket(
        WS_URL,
        {
            share: true,
            shouldReconnect: () => true,
            heartbeat: {
                message: "ping",
                returnMessage: "pong",
                timeout: 60000,
                interval: 25000,
            },
        },
        config.webSocketEnabled,
    );


    const { lastResultMessage } = use(NotificationContext);


    const popupResultMessageToast =
        useCallback((lastJsonMessage: unknown, lastMessage: MessageEvent<string | undefined> | null) => {
            if (isResultMessage(lastJsonMessage)) {
                toast(
                    <Toast
                        variant="outline-colour"
                        type={lastJsonMessage?.status}
                        alertData={{
                            heading: lastJsonMessage.title,
                            message: lastJsonMessage.message,
                        }}
                    />,
                    {
                        closeButton: false,
                        hideProgressBar: true,
                        className: "p-0 w-[400px]",
                    }
                );
            } else if (lastMessage) {
                toast(
                    <Toast
                        variant="outline-colour"
                        type={"NONE"}
                        alertData={{
                            message: lastMessage?.data,
                        }}
                    />,
                    {
                        closeButton: false,
                        hideProgressBar: true,
                        className: "p-0 w-[400px]",
                    }
                );
            }
        }, []);


    // Run when a new WebSocket message is received (lastJsonMessage / lastMessage)
    useEffect(() => {
        popupResultMessageToast(lastJsonMessage, lastMessage);
    }, [ lastJsonMessage, lastMessage, popupResultMessageToast ]);

    // Run when a new Context message is received (lastResultMessage)
    useEffect(() => {
        popupResultMessageToast(lastResultMessage, null);
    }, [ lastResultMessage, popupResultMessageToast ]);


    return (
        <>
            <ToastContainer
                stacked
                position="bottom-right"
                transition={Slide}
            />
        </>
    );
};

export default Notification;
